import Modal from 'react-bootstrap/Modal';
import { Field, Form, Formik } from "formik";
import { TextField } from "../../components/common/TextField/TextField";
import React, { useEffect, useState } from "react";
import { OptionList } from "../../components/common/OptionList/OptionList";
import { Col, Row, Spinner } from "react-bootstrap";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { filesTo, fileUrl } from "../../api/api";
import ShowNotification from "../../components/common/Notification/ShowNotification";

const productTypesData = [
    { id: 1, name: "Nevrologiya" },
    { id: 2, name: "Kardiologiya" },
    { id: 3, name: "Travmatologiya" },
    { id: 4, name: "Daxili xəstəliklər" },
    { id: 5, name: "Revmatologiya" },
    { id: 6, name: "Endokrinologiya" },
    { id: 7, name: "Ortopediya" },
    { id: 8, name: "Radiologiya" },
    { id: 9, name: "İmmunologiya" },
    { id: 10, name: "Digər" }
];

const EditDataModal = ({ show, setIsEditBlog, deleteBlogTh, blogs, updateBlogTh, blogId, ...props }) => {
    let product = blogs.find((item) => item.id == parseInt(blogId)) || {};

    let [showModal, setShowModal] = useState(show);
    let [showDeleteModal, setShowDeleteModal] = useState(false);
    let [content, setContent] = useState("");
    let [imageUrl, setImageUrl] = useState("");
    let [status, setStatus] = useState(1);
    let [isUploading, setIsUploading] = useState(false);

    const handleClose = () => {
        setIsEditBlog(false);
    };

    const saveCkEditorHTML = (e, editor) => {
        setContent(editor.getData());
    };

    // Preview URL-i təhlükəsiz qururuq: backend "abc.jpg" və ya "files/abc.jpg" qaytara bilər
    const buildPreviewUrl = (path) => {
        if (!path) return "";
        if (path.startsWith("http")) return path;
        const base = fileUrl.replace(/\/+$/, "");
        const normalized = path.replace(/^\/+/, "").startsWith("files/")
            ? path.replace(/^\/+/, "")
            : `files/${path.replace(/^\/+/, "")}`;
        return `${base}/${normalized}`;
    };

    useEffect(() => {
        setShowModal(show);
        const currentProduct = blogs.find((item) => item.id == parseInt(blogId));
        if (currentProduct) {
            setContent(currentProduct.content || "");
            setImageUrl(currentProduct.imgUrl || "");
            setStatus(currentProduct.status ?? 1);
        }
    }, [show, blogId, blogs]);

    const handleFileChange = async (e, setFieldValue) => {
        const file = e.target.files[0];
        if (!file) return;

        setIsUploading(true);
        const folderType = "blog";

        try {
            const responseFileLoad = await filesTo.add(file, folderType);

            if (responseFileLoad && responseFileLoad.status === 200) {
                ShowNotification("Uğurlu", "Şəkil yükləndi", "success");
                const filePath = responseFileLoad.data.url;
                setImageUrl(filePath);
                setFieldValue("imgUrl", filePath);
            } else {
                ShowNotification("Xəta", responseFileLoad?.data?.message || "Şəkil yüklənmədi", "danger");
            }
        } catch (error) {
            ShowNotification("Xəta", "Şəkil yüklənərkən xəta baş verdi", "danger");
        } finally {
            setIsUploading(false);
        }
    };

    let statList = [
        { id: 0, name: 'Deactive', status: 1 },
        { id: 1, name: 'Active', status: 1 }
    ];

    return (
        <Formik
            enableReinitialize={true}
            initialValues={{
                id: product.id || '',
                title: product.title || '',
                youtubeLink: product.youtubeLink || '',
                status: status,
                product_type_id: product.product_type_id ? String(product.product_type_id) : '',
                imgUrl: imageUrl || product.imgUrl || '',
            }}
            onSubmit={(formValues) => {
                if (isUploading) {
                    ShowNotification("Xəbərdarlıq", "Zəhmət olmasa şəklin yüklənməsini gözləyin", "warning");
                    return;
                }

                const productInstance = {
                    id: formValues.id,
                    title: formValues.title,
                    content: content,
                    status: parseInt(status),
                    product_type_id: formValues.product_type_id ? parseInt(formValues.product_type_id) : null,
                    imgUrl: imageUrl || formValues.imgUrl,
                    youtubeLink: formValues.youtubeLink ? formValues.youtubeLink.replace("watch?v=", "embed/") : "",
                };

                console.log("Göndərilən Data:", productInstance); // Console-da dəqiqləşdirmək üçün
                updateBlogTh(productInstance);
                setIsEditBlog(false);
            }}
        >
            {({ setFieldValue, values, handleChange }) => (
                <>
                    {/* Silmə Təsdiq Modalı */}
                    <Modal size="sm" show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Silinməni təsdiq edin</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="text-center">
                            Bu blogu silmək istədiyinizdən əminsiniz?
                        </Modal.Body>
                        <Modal.Footer className="justify-content-center">
                            <button
                                type="button"
                                className="btn btn-danger mr-2"
                                onClick={() => {
                                    deleteBlogTh(product.id);
                                    setShowDeleteModal(false);
                                    setIsEditBlog(false);
                                }}
                            >
                                Blogu sil
                            </button>
                            <button
                                type="button"
                                onClick={() => setShowDeleteModal(false)}
                                className="btn btn-secondary"
                            >
                                Geri qayıt
                            </button>
                        </Modal.Footer>
                    </Modal>

                    {/* Əsas Edit Modalı */}
                    <Modal size="lg" show={showModal && !showDeleteModal} onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title>Blog redaktə et</Modal.Title>
                        </Modal.Header>
                        <Form>
                            <Modal.Body>
                                <TextField
                                    label="Blogun Adı"
                                    name="title"
                                    type="text"
                                    enableLabel="true"
                                />

                                {/* Kateqoriya Seçimi */}
                                <div className="form-group mb-3">
                                    <label className="form-label font-weight-bold">Kateqoriya (Product Type)</label>
                                    <select
                                        name="product_type_id"
                                        className="form-control shadow-none"
                                        value={values.product_type_id}
                                        onChange={handleChange}
                                    >
                                        <option value="">-- Kateqoriya Seçin --</option>
                                        {productTypesData.map((type) => (
                                            <option key={type.id} value={String(type.id)}>
                                                {type.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-group mb-3">
                                    <label className="form-label font-weight-bold">Kontent</label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={content || ""}
                                        name="content"
                                        onChange={saveCkEditorHTML}
                                    />
                                </div>

                                <Row className="mb-3">
                                    <Col md={6}>
                                        <OptionList
                                            label="Status"
                                            data={statList}
                                            name="status"
                                            selectedItem={status}
                                            setData={setStatus}
                                        />
                                    </Col>
                                </Row>

                                {/* Şəkil Yükləmə */}
                                <div className="form-group mb-3">
                                    <label className="form-label font-weight-bold">Şəkil Dəyişdir</label>
                                    <Row className="align-items-center">
                                        <Col md={12}>
                                            <input
                                                name="file"
                                                id="upload"
                                                type="file"
                                                accept="image/*"
                                                className="form-control shadow-none"
                                                onChange={(e) => handleFileChange(e, setFieldValue)}
                                            />
                                        </Col>
                                        {isUploading && (
                                            <Col md={12} className="mt-2 text-info">
                                                <Spinner animation="border" size="sm" /> Şəkil yüklənir...
                                            </Col>
                                        )}
                                    </Row>

                                    {/* Ön-baxış */}
                                    {(imageUrl || values.imgUrl) && !isUploading && (
                                        <div className="mt-2">
                                            <small className="text-muted d-block mb-1">Mövcud / Yeni Şəkil:</small>
                                            <img
                                                src={buildPreviewUrl(imageUrl || values.imgUrl)}
                                                alt="Preview"
                                                style={{ maxHeight: "120px", borderRadius: "5px", objectFit: "cover" }}
                                            />
                                        </div>
                                    )}
                                </div>

                                <TextField
                                    label="Youtube Link"
                                    name="youtubeLink"
                                    type="text"
                                    enableLabel="true"
                                />
                            </Modal.Body>
                            <Modal.Footer>
                                <button
                                    type="button"
                                    className="btn btn-danger mr-auto"
                                    onClick={() => setShowDeleteModal(true)}
                                >
                                    Blogu sil
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={handleClose}
                                >
                                    Bağla
                                </button>
                                <button
                                    type="submit"
                                    disabled={isUploading}
                                    className="btn btn-primary"
                                >
                                    Yadda saxla
                                </button>
                            </Modal.Footer>
                        </Form>
                    </Modal>
                </>
            )}
        </Formik>
    );
};

export default EditDataModal;
